
import 'vue-custom-scrollbar/dist/vueScrollbar.css' // todo to main.css
import TermsAndConditionsText from './TermsAndConditionsText'
import TermsAndConditionsMenu from './TermsAndConditionsMenu'
import ui from '~/ZenOne-StoryBook/mixins/ui'
import { SETTINGS_ROUTE_NAME } from '~/helpers/route'
import { isHavingLength } from '~/ZenOne-StoryBook/helpers/array'
export default {
  name: 'TermsAndConditionsDialog',
  components: {
    TermsAndConditionsMenu,
    TermsAndConditionsText,
  },
  mixins: [ui],
  data() {
    return {
      dialog: false,
      bottomLayerSelector:
        '.layout-default__top-menu, .pg-settings, .pg-settings-wr--settings-menu, .pg-registration, .recharge-subscription-banner, .notification-top, .wizard-wrapper, .logo'
    }
  },
  computed: {
    routeName() {
      return this.$route.name
    },
  },
  methods: {
    open() {
      const { routeName = SETTINGS_ROUTE_NAME } = this
      this.hideBottomLayer()
      history.replaceState(null, null, `/${routeName}#services`)
      this.dialog = true
    },
    close() {
      const { routeName = SETTINGS_ROUTE_NAME } = this
      this.showBottomLayer()
      history.replaceState(null, null, `/${routeName}`)
      this.dialog = false
      this.$emit('termsAndConditionsDialogClosed')
    },
    hideBottomLayer() {
      const elementListToHide = document.querySelectorAll(this.bottomLayerSelector)
      if (elementListToHide && isHavingLength(elementListToHide)) {
        elementListToHide.forEach((el) => el.classList.add('!hidden'))
      }
    },
    showBottomLayer() {
      const elementListToShow = document.querySelectorAll(this.bottomLayerSelector)
      if (elementListToShow && isHavingLength(elementListToShow)) {
        elementListToShow.forEach((el) => el.classList.remove('!hidden'))
      }
    },
  },
}
